
import {
  Component,
  OnInit,
  ɵConsole,
  Output,
  EventEmitter,
  AfterViewInit
} from "@angular/core";
import { ElementRef, Input, ViewChild } from "@angular/core";
import { HttpClient, HttpEventType } from "@angular/common/http";
import { GlobalService } from "../../services/global.service";
import { AmazonWebService } from "../../services/amazon-web.service";
import { HotelProfileModel } from "../../models/request/hotelProfile.model";
import { ResultModel } from "src/app/core/models/response/base.model";
import { EventModel } from "../../models/response/event.model";
import { Globals } from "../../globals";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { SliderShowModalComponent } from "src/app/core/modals/slider-show-modal/slider-show-modal.component";
import { TranslateService } from "@ngx-translate/core";
import { ConfirmDialogModalComponent } from "../../modals/confirm-dialog-modal/confirm-dialog-modal.component";
import { takeUntil } from "rxjs/internal/operators/takeUntil";
import { SharedService } from "src/app/shared.service";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

@Component({
  selector: "file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.scss"]
})
export class FileUploadComponent implements OnInit {
  private readonly MAX_IMAGE_SIZE_BYTES = 2 * 1024 * 1024;
  private readonly TARGET_IMAGE_SIZE_BYTES = 1 * 1024 * 1024;
  private readonly MAX_PDF_SIZE_BYTES = 3 * 1024 * 1024;
  uploadSubscribe$;
  deletSubscribe$;
  public hotelProfileModel: HotelProfileModel = new HotelProfileModel();
    viewImage(url: string) {
      if (url) {
        this.dialog.open(SliderShowModalComponent, {
          data: {
            clickImage: url,
            allImages: [url]
          },
      width: '440px',
      height: 'auto',
      disableClose: false,
      panelClass: 'slide-image',        });
      }
    }
  public eventModel: EventModel = new EventModel();
  public progress: { percentage: number } = { percentage: 0 };
  public imagePath;
  public imgErrorMessage: string;
  @Input() imgUrl: any;
  @Output() outImgUrl= new EventEmitter();
  @Input() deleteStatus: false;
  @Input() imgArray = [];
  @Output() imageUpload = new EventEmitter();
  @Output() deletedImage = new EventEmitter();
  @Output() upload = new EventEmitter();
  @Input() locationStatus: string;
  @Input() locationUploadType: string;
  @Input() uploadFolder: string; //Uploaded Folder
  @Input() fileName: string;
  @ViewChild('file') public file: ElementRef;
  @ViewChild('fileInput') public fileInput: ElementRef; 
  @ViewChild('pdfInput') public pdfInput: ElementRef; 
  isFileInputClicked: boolean = false;
  isPdfInputClicked: boolean = false;
     public uploadFolderArray = []; //To push Upload Folder
  constructor(
    public globalService: GlobalService,
    private amazonWebService: AmazonWebService,
    public globals: Globals,
    private dialog: MatDialog,
    private translate: TranslateService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
   
    //if location is
    // this.globalService.showLoader = true;
  }

  ngOnDestroy() {
    if (this.uploadSubscribe$) {
      this.uploadSubscribe$.unsubscribe();
    }

    if (this.deletSubscribe$) {
      this.deletSubscribe$.unsubscribe();
    }
  }
  // ngAfterViewInit(){
  //   this.fileInput;
  //   this.pdfInput
  // }
  triggerFileInput(event: MouseEvent, fileInput: HTMLElement) {
    event.stopPropagation();
    if (!this.isFileInputClicked) {
      this.isFileInputClicked = true;
      fileInput.click();
    }
  }

  triggerPdfFileInput(event: MouseEvent, pdfInput: HTMLElement) {
    event.stopPropagation();
    if (!this.isPdfInputClicked) {
      this.isPdfInputClicked = true;
      pdfInput.click();
    }
  }
  removeDuplicateUsingFilter(arr) {
    let unique_array = arr.filter(function(elem, index, self) {
      return index == self.indexOf(elem);
    });
    return unique_array;
  }

  pdfPreview(files) {
    this.imgErrorMessage = "";
    if (files.length === 0) return;

    var mimeType = files[0].type;
          if (mimeType.match(/pdf\/*/) == null) {
      this.imgErrorMessage = "Only pdf are supported.";
      return;
    }

    if (files[0].size > this.MAX_PDF_SIZE_BYTES) {
      this.globalService.handleErrorMessage(
        "PDF size must be less than or equal to 3MB."
      );
      if (this.pdfInput && this.pdfInput.nativeElement) {
        this.pdfInput.nativeElement.value = "";
      }
      this.isPdfInputClicked = false;
      return;
    }

    this.fileName = files[0].name;
    var reader = new FileReader();

    if (this.locationStatus == "pdfUpload") {
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imgUrl = reader.result;
        this.upload.emit(files);
      };
    };
    if (this.locationStatus ==="pdfUploadInternal") {
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imgUrl = reader.result;
        this.outImgUrl.emit(this.imgUrl);
        this.isPdfInputClicked = false;
        this.upload.emit(files);
      };
    }
  }
  reset() {
    this.imgUrl = ''; // Clear image URL
    if (this.fileInput) {
      this.fileInput.nativeElement.value = ''; // Clear any previously selected file
    }
    if (this.pdfInput) {
      this.pdfInput.nativeElement.value = ''; // Clear any previously selected file
    }
  }

  preview(files) {
    this.imgErrorMessage = "";
    if (files.length === 0) return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.imgErrorMessage = "Only images are supported.";
      return;
    }

    var reader = new FileReader();
    if (this.locationStatus == "singleImage") {
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imgUrl = reader.result;
        // this.currentFileUpload = files.item(0);
        // this.currentFileName = files[0].name;
        this.outImgUrl.emit(this.imgUrl);
        this.imageUpload.emit(files); //Fire Child Event
               this.clearDom();
      };
    };
    if (this.locationStatus === "parentLocationStatus") {
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imgUrl = reader.result;
        // this.currentFileUpload = files.item(0);
        // this.currentFileName = files[0].name;
        this.outImgUrl.emit(this.imgUrl);
        this.imageUpload.emit(files); //Fire Child Event
               this.isFileInputClicked = false;
        this.clearDomfile();
        this.isFileInputClicked = false;
      };
    }

    if (this.locationStatus == "imageEdit") {
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imgUrl = reader.result;
        this.imageUpload.emit(files);
      };
    }
    if (this.locationStatus == "editProfile") {
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imgUrl = reader.result;
        this.imageUpload.emit(files);
      };
    }

    if (this.locationStatus == "singleInstantUpload") {
      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imgUrl = reader.result;
        // this.currentFileUpload = files.item(0);
        // this.currentFileName = files[0].name;

        this.imageUpload.emit(files); //Fire Child Event
             };
    }

    if (this.locationStatus == "rotatingImages") {
      this.uploadFolderArray = [];
      this.uploadFolderArray.push(this.uploadFolder);

      // const findIndexUploadFolder = this.uploadFolderArray.findIndex(
      //   //Check Index Exists
      //   e => e === this.uploadFolder
      // );

      // if (findIndexUploadFolder === -1) {
      //   this.uploadFolderArray = [];
      //   //If Index does not exists
      //   //Push Image To the Array
      //   this.uploadFolderArray.push(this.uploadFolder);
      //   this.imgArray = []; //emptied the Image Array
      // }

      this.imagePath = files;
      reader.readAsDataURL(files[0]);
      reader.onload = async _event => {
        this.imgUrl = reader.result;
        // this.currentFileUpload = files.item(0);
        // this.currentFileName = files[0].name;

        let uploadFile = files.item(0);
        if (uploadFile && uploadFile.size > this.MAX_IMAGE_SIZE_BYTES) {
          this.globalService.handleErrorMessage(
            "Image size must be less than or equal to 2MB."
          );
          this.isFileInputClicked = false;
          this.clearDomfile();
          return;
        }

        if (uploadFile && uploadFile.size > this.TARGET_IMAGE_SIZE_BYTES) {
          const compressedFile = await this.compressFileToTargetSize(
            uploadFile,
            this.TARGET_IMAGE_SIZE_BYTES
          );

          if (!compressedFile) {
            this.globalService.handleErrorMessage(
              "Image could not be compressed to 1MB. Please try a different image."
            );
            this.isFileInputClicked = false;
            this.clearDomfile();
            return;
          }

          uploadFile = compressedFile;
        }

        this.globalService.showLoader = true;
        this.amazonWebService.uploadObject(
          uploadFile.name,
          uploadFile,
          "private",
          this.uploadFolder
        );

        this.uploadSubscribe$ = this.amazonWebService.processCompleted
          .pipe(takeUntil(this.globalService.componentDestroyed(this)))
          .subscribe(
            response => {
              if (response.data.Location) {
                this.globalService.showLoader = false;
                const findIndexUploadFolder = this.uploadFolderArray.findIndex(
                  //Check Index Exists
                  e => e === response.data.FolderName
                );
                this.isFileInputClicked = false;
                                                                                           if (this.uploadFolder === response.data.FolderName) {
                  //Check If Upload Folder is the Same
                  if (this.imgArray) {
                    // Check If array exists
                    const index = this.imgArray.findIndex(
                      //Check Index Exists
                      e =>
                        e ===
                        this.globals.S3Url +
                          this.globalService.getHostname() +
                          "/" +
                          this.uploadFolder +
                          "/" +
                          response.data.Location
                    );

                    if (index === -1) {
                      //If Index does not exists
                      //Push Image To the Array
                      this.imgArray.push(
                        this.globals.S3Url +
                          this.globalService.getHostname() +
                          "/" +
                          this.uploadFolder +
                          "/" +
                          response.data.Location
                      );
                    }
                  } else {
                    this.imgArray.push(
                      this.globals.S3Url +
                        this.globalService.getHostname() +
                        "/" +
                        this.uploadFolder +
                        "/" +
                        response.data.Location
                    );
                  }

                  //Check Image Duplicacy
                  this.imgArray = this.removeDuplicateUsingFilter(
                    this.imgArray
                  );

                  //Emit the Image Array
                  this.imageUpload.emit({
                    imgArray: this.imgArray,
                    uploadFolder: this.uploadFolder
                  });
                }
              }
            },
            error => {
              this.globalService.showLoader = false;
              this.globalService.handleApiError(error);
              return false;
            }
          );
      };
    }
  }

  private readFileAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result as string);
      fileReader.onerror = () => reject(fileReader.error);
      fileReader.readAsDataURL(file);
    });
  }

  private getBase64SizeInBytes(base64: string): number {
    const base64Data = (base64 || "").split(",")[1] || "";
    const padding = (base64Data.match(/=+$/) || [""])[0].length;
    return Math.ceil((base64Data.length * 3) / 4) - padding;
  }

  private dataUrlToFile(dataUrl: string, originalName: string): File | null {
    try {
      const arr = dataUrl.split(",");
      const mimeMatch = arr[0].match(/:(.*?);/);
      const mime = mimeMatch ? mimeMatch[1] : "image/jpeg";
      const extension = mime.split("/")[1] || "jpg";
      const safeName =
        (originalName || "image")
          .replace(/\.[^/.]+$/, "")
          .replace(/\s+/g, "_") +
        "." +
        extension;
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], safeName, { type: mime });
    } catch {
      return null;
    }
  }

  private async compressFileToTargetSize(
    file: File,
    targetBytes: number
  ): Promise<File | null> {
    try {
      const base64 = await this.readFileAsDataURL(file);
      const compressedDataUrl = await this.compressDataUrlToTarget(
        base64,
        targetBytes
      );
      if (!compressedDataUrl) {
        return null;
      }

      const compressedFile = this.dataUrlToFile(compressedDataUrl, file.name);
      return compressedFile;
    } catch {
      return null;
    }
  }

  private compressDataUrlToTarget(
    dataUrl: string,
    targetBytes: number
  ): Promise<string | null> {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = dataUrl;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        if (!context) {
          resolve(null);
          return;
        }

        let width = image.width;
        let height = image.height;
        const maxDimension = 2200;
        const minDimension = 480;

        if (width > height && width > maxDimension) {
          height = Math.round(height * (maxDimension / width));
          width = maxDimension;
        } else if (height > maxDimension) {
          width = Math.round(width * (maxDimension / height));
          height = maxDimension;
        }

        const draw = (w: number, h: number, quality: number): string => {
          canvas.width = w;
          canvas.height = h;
          context.clearRect(0, 0, w, h);
          context.drawImage(image, 0, 0, w, h);
          return canvas.toDataURL("image/jpeg", quality);
        };

        const findBestByQuality = (w: number, h: number): { dataUrl: string; size: number } => {
          let low = 0.45;
          let high = 0.92;
          let bestDataUrl = draw(w, h, low);
          let bestSize = this.getBase64SizeInBytes(bestDataUrl);

          for (let i = 0; i < 7; i++) {
            const mid = (low + high) / 2;
            const candidate = draw(w, h, mid);
            const candidateSize = this.getBase64SizeInBytes(candidate);

            if (candidateSize <= targetBytes) {
              bestDataUrl = candidate;
              bestSize = candidateSize;
              low = mid;
            } else {
              high = mid;
            }
          }

          if (bestSize > targetBytes) {
            const fallback = draw(w, h, 0.45);
            return { dataUrl: fallback, size: this.getBase64SizeInBytes(fallback) };
          }

          return { dataUrl: bestDataUrl, size: bestSize };
        };

        let attempt = findBestByQuality(width, height);
        let resizeSteps = 0;

        while (
          attempt.size > targetBytes &&
          width > minDimension &&
          height > minDimension &&
          resizeSteps < 6
        ) {
          width = Math.max(minDimension, Math.round(width * 0.88));
          height = Math.max(minDimension, Math.round(height * 0.88));
          attempt = findBestByQuality(width, height);
          resizeSteps++;
        }

        resolve(attempt.size <= targetBytes ? attempt.dataUrl : null);
      };

      image.onerror = () => resolve(null);
    });
  }
  removeSingleImageFromParent(imgUrl){
    let splitImgUrl = imgUrl.split("/");
    let fetchImage = splitImgUrl[splitImgUrl.length - 1];
    let imgType = fetchImage.split(".").pop();
    this.globalService.showLoader = true;

        //Delete Api Request With Aws Signed Url
        this.amazonWebService.deleteObject(
          fetchImage,
          imgType,
          "private",
          this.uploadFolder
        );

        // Subscribe To Delete event after Success Delete Image From Bucket
        this.deletSubscribe$ = this.amazonWebService.deleteProcessCompleted.subscribe(
          response => {
            this.globalService.showLoader = false;
            this.imgUrl = "";
            this.sharedService.deleteSingleImage.emit(this.uploadFolder);
          },
          error => {
            this.globalService.showLoader = false;
            this.globalService.handleApiError(error);
            return false;
          }
        );
  }
  removeSingle(imgUrl) {
    //Split ImageUrl to find image name and type
    let splitImgUrl = imgUrl.split("/");
    let fetchImage = splitImgUrl[splitImgUrl.length - 1];
    let imgType = fetchImage.split(".").pop();

    //Dialog Confirmation for Delete Image Gallery
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = "delete-dialog";
    dialogConfig.data = {
      id: 1,
      title: this.translate.instant("DeleteCustomMessage")
    };

    const dialogRef = this.dialog.open(
      ConfirmDialogModalComponent,
      dialogConfig
    );
   

    dialogRef.afterClosed().subscribe(result => {
                if (result) {
        this.globalService.showLoader = true;

        //Delete Api Request With Aws Signed Url
        this.amazonWebService.deleteObject(
          fetchImage,
          imgType,
          "private",
          this.uploadFolder
        );

        // Subscribe To Delete event after Success Delete Image From Bucket
        this.deletSubscribe$ = this.amazonWebService.deleteProcessCompleted.subscribe(
          response => {
            this.globalService.showLoader = false;
            this.imgUrl = "";
            this.sharedService.deleteSingleImage.emit(this.uploadFolder);
            this.deletedImage.emit(true);
          },
          error => {
            this.globalService.showLoader = false;
            this.globalService.handleApiError(error);
            return false;
          }
        );
      }
    });
  }

  removeDomImage(index, imgUrl) {
    // if (this.imgArray.length > 0) {
    //   this.imgArray.splice(index, 1);
    // }
    //Split ImageUrl to find image name and type
    let splitImgUrl = imgUrl.split("/");
    let fetchImage = splitImgUrl[splitImgUrl.length - 1];
    let imgType = fetchImage.split(".").pop();

    //Dialog Confirmation for Delete Image Gallery
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = "delete-dialog";
    dialogConfig.data = {
      id: 1,
      title: this.translate.instant("DeleteCustomMessage")
    };
    const dialogRef = this.dialog.open(
      ConfirmDialogModalComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe(result => {
                if (result) {
        this.globalService.showLoader = true;
        this.imgArray.splice(index, 1);
        //Delete Api Request With Aws Signed Url
        this.amazonWebService.deleteObject(
          fetchImage,
          imgType,
          "private",
          this.uploadFolder
        );

        // Subscribe To Delete event after Success Delete Image From Bucket
        this.deletSubscribe$ = this.amazonWebService.deleteProcessCompleted.subscribe(
          response => {
            this.globalService.showLoader = false;
            //Check If Upload Folder is the Same as Delete folder
            if (this.uploadFolder === response.data.FolderName) {
              if (this.imgArray) {
                // Check If array exists
                const exists = this.imgArray.findIndex(
                  //Check Index Exists
                  e =>
                    e ===
                    this.globals.S3Url +
                      this.globalService.getHostname() +
                      "/" +
                      this.uploadFolder +
                      "/" +
                      response.data.Location
                );
                if (exists === -1) {
                  //If Image not exists

                  //Check Image Duplicacy
                  this.imgArray = this.removeDuplicateUsingFilter(
                    this.imgArray
                  );

                  //Emit the Image Array
                  this.imageUpload.emit({
                    imgArray: this.imgArray,
                    uploadFolder: this.uploadFolder
                  });
                } else {
                  // this.imgArray.splice(index, 1);
                }
              } else {
                //Remove  Image From Dom
                // this.imgArray.splice(index, 1);
              }
            }
          },
          error => {
            this.globalService.showLoader = false;
            this.globalService.handleApiError(error);
            return false;
          }
        );
      }
    });
  }

  delete(imgUrl, location) {
    let splitImgUrl = imgUrl.split("/");
    let fetchImage = splitImgUrl[splitImgUrl.length - 1];
    let imgType = fetchImage.split(".").pop();

    //Dialog Confirmation for Delete Image Gallery
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: 1,
      title: this.translate.instant("DeleteCustomMessage")
    };
    const dialogRef = this.dialog.open(
      ConfirmDialogModalComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe(result => {
                if (result) {
        this.globalService.showLoader = true;

        //Delete Api Request With Aws Signed Url
        this.amazonWebService.deleteObject(
          fetchImage,
          imgType,
          "private",
          location
        );

        // Subscribe To Delete event after Success Delete Image From Bucket
        this.deletSubscribe$ = this.amazonWebService.deleteProcessCompleted.subscribe(
          response => {
            if (response.data.Filename) {
              this.globalService.showLoader = false;
              this.sharedService.deletePdfEvent.emit(imgUrl);
            }
          },
          error => {
            this.globalService.showLoader = false;
            this.globalService.handleApiError(error);
            return false;
          }
        );
      }
    });
  }


  /**
   * Clears dom
   */
  clearDom(){
    this.file.nativeElement.value = "";

  }
  clearDomfile(){
    this.fileInput.nativeElement.value = "";
  }

  // drop(event: CdkDragDrop<string[]>) {
  //   if (this.imgArray && this.imgArray.length) {
  //     moveItemInArray(this.imgArray, event.previousIndex, event.currentIndex);
  //   }
  // }
}
